import { render, staticRenderFns } from "./comicList.vue?vue&type=template&id=1459f5e3&scoped=true&"
import script from "./comicList.vue?vue&type=script&lang=js&"
export * from "./comicList.vue?vue&type=script&lang=js&"
import style0 from "./comicList.vue?vue&type=style&index=0&id=1459f5e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1459f5e3",
  null
  
)

export default component.exports